import styled from "styled-components";

export const Container = styled.div``;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 12px 20px;
  background: var(--filter-bar-bg);
  align-items: center;
  flex-wrap: wrap;
  row-gap: 10px;
  .add-new-feature {
    button {
      padding: 5px 12px;
    height: auto;
    min-height: 31px;
    text-align: left;
    }
  }
  .label-wrapper {
    display: flex;
    align-items: center;
    border-right: 1px solid #cdcfd0;
    padding: 0 15px;
    gap: 15px;
    min-height: 30px;
    label {
      font-size: 13px;
      line-height: 16px;
      white-space: nowrap;
      color: var(--theme-text);
      font-family: "latoregular";
    }
  }
  .product {
    font-family: "latobold";
    font-size: 16px;
    line-height: 150.5%;
    color: var(--theme-text);
  }
  button {
    color: var(--theme-text);
    border-color: var(--theme-background);
    svg {
      fill: var(--input-background);
    }
  }
`;

export const CheckBoxWrapper = styled.div`
  background: var(--input-background);
  border: 1px solid #cdcfd0;
  border-radius: 6px;
  padding: 0 10px;
  display: flex;
  min-height: 30px;
  .MuiFormControlLabel-label {
    font-size: 13px;
    line-height: 150.5%;
    font-family: "latoregular";
    white-space: break-spaces;
  }
  .MuiButtonBase-root {
    padding: 5px;
    padding-left: 0;
  }
  .MuiFormControlLabel-root {
    margin: 0;
  }
`;

export const FormWrapper = styled.div`
  margin: 15px 20px;
  padding: 10px 5px 10px 20px;
  background: #f0eeed;
  border: 1px solid #ffffff;
  border-radius: 10px;
  justify-content: center;
  &.modal-table-wrapper {
    max-height: calc(100vh - 400px);
    overflow: auto;
  }
`;

export const BodyWrapper = styled.div`
  display: flex;
  &.no-pagination{
    .MuiDataGrid-footerContainer {
      display: none !important;
    }
  }
  .table-wrapper {
    height: calc(100vh - 112px);
    padding: 35px 35px 35px 35px;
  }
  @media (max-width: 850px) {
    display: none;
  }
`;

export const AddFeatureSetDatePickerWrapper = styled.div`
  padding: 17px 25px 15px;
  display: flex;
  align-items: center;
  gap: 18px;
  .label-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    .MuiFormControl-root {
      max-width: 169px;
    }
    .MuiInputBase-input {
      font-size: 14px;
      line-height: 150.5%;
      padding: 5px 14px;
    }
    .label {
      font-size: 14px;
      line-height: 150.5%;
    }
  }
  @media (max-width: 510px) {
    flex-direction: column;
    align-items: flex-start;
     .label-wrapper {
      display: grid;
    grid-template-columns: 70px 1fr;
    .MuiFormControl-root {
      max-width: 100%;
    }
    }
  }
`;

export const MobileSection = styled.div`
  display: none;
  .wrapper {
    padding: 10px 13px;
    background-color: #e6e6e6;
    .mobile-table-ui {
      margin-bottom: 10px;
      .row {
        display: grid;
        grid-template-columns: 100px 1fr 1fr;
        border-bottom: 1px solid #e7e7e7;
        > p {
          text-align: center;
          background: #f4f4d4;
          min-height: 43px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 4px 5px 4px 13px;
          font-weight: 400;
          font-size: 13px;
          line-height: 150.5%;
          border-left: 1px solid #e7e7e7;
          :first-child {
            justify-content: left;
            background: #fff;
            font-weight: 500;
            border-left: none;
          }
        }
      }
    }
    .activated-features {
      background-color: #fff;
      .heading {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 11px;
        h4 {
          font-weight: 500;
          font-size: 14px;
          line-height: 150.5%;
        }
      }
    }
    .main-checkbox-wrapper {
      background-color: #f4f4d4;
      padding: 16px 14px;
      max-height: calc(100vh - 680px);
      overflow: auto;
      /* min-height: calc(100vh - 656px);
      overflow: auto; */
    }
    .slider-wrapper {
      padding-bottom: 55px;
      background-color: #e6e6e6;
      .slick-arrow {
        bottom: -60px;
        top: unset;
        z-index: 1;
        height: 26px;
        ::before {
          display: none;
        }
        svg {
          position: absolute;
          top: 0;
        }
      }
      .slick-prev {
        left: 35%;
      }
      .slick-next {
        right: 35%;
      }
      .slick-disabled {
        opacity: 0.5;
      }
    }
  }
  @media (max-width: 850px) {
    display: block;
    .wrapper {
      .main-checkbox-wrapper {
        background-color: #f4f4d4;
        padding: 16px 14px;
        max-height: calc(100vh - 609px);
      }
    }
  }
`;
